import type { ReactNode } from 'react'
import { cn } from '../lib/cn.js'

export type Tone = 'neutral' | 'ok' | 'warn' | 'bad'

const TONES: Record<Tone, string> = {
  neutral: 'bg-line-soft text-muted',
  ok: 'bg-accent-soft text-accent',
  warn: 'bg-copper-soft text-copper',
  bad: 'bg-crimson-soft text-crimson',
}

/**
 * Метка состояния. Цвет здесь несёт смысл, поэтому он никогда не единственный
 * носитель: рядом всегда стоит текст. Человек, не различающий зелёный
 * и красный, должен читать состояние так же быстро, как и все остальные.
 */
export function Badge({
  tone = 'neutral',
  children,
  className,
}: {
  tone?: Tone
  children: ReactNode
  className?: string
}) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-medium whitespace-nowrap',
        TONES[tone],
        className,
      )}
    >
      {children}
    </span>
  )
}

/** Точка состояния для мест, где текст стоит рядом отдельно. */
export function StatusDot({ tone = 'neutral' }: { tone?: Tone }) {
  const color: Record<Tone, string> = {
    neutral: 'bg-muted',
    ok: 'bg-accent',
    warn: 'bg-copper',
    bad: 'bg-crimson',
  }

  return <span aria-hidden="true" className={cn('size-2 shrink-0 rounded-full', color[tone])} />
}
